import config from 'services/config'

const assetURL = config.s3AssetsUrl + '/email-icons'

const getBaseEmailTemplate = ({
  hotelDetails: {
    primaryWebsiteUrl,
    latitude,
    longitude,
    invoiceAddress,
    hotelName,
    reservationHotLine
  },
  brand: { colors },
  coloredLogoUrl = `${config.s3AssetsUrl}/sample-email-images/coloredLogo.jpg`,
  whiteLogoUrl = `${config.s3AssetsUrl}/sample-email-images/whiteLogo.jpg`,
  hotelPhoneNumber = '',
  sections = {
    main: {
      title: 'Sinan, book now and get up to 20% discount on your stay!',
      description:
        'Blandit tristique ante at sed id at lorem sem. Est libero erat felis purus fames lacus lectus tellus vitae. Fames rutrum est bibendum sem duis maecenas dolor accumsan nibh bibendum sem duis maecenas dolor',
      cta: 'Book with 20% discount',
      ctaLink: ''
    },
    aboutHotel: {
      title: 'Explore our hotel',
      description:
        'Blandit tristique ante at sed id at lorem sem. Est libero erat felis purus fames lacus lectus tellus vitae. Fames rutrum est bibendum sem duis maecenas dolor accumsan nibh bibendum sem duis maecenas dolor',
      photos: ['']
    },
    address: {
      googleMapsImgUrl:
        'https://maps.googleapis.com/maps/api/staticmap?center=31.893314,-106.438194&zoom=17&size=2560x200&maptype=roadmap&key=AIzaSyB2Q7iadrg9-SaymDF_l5pUOhLaOiW01vM'
    }
  }
}) => `<mjml>
<mj-head>
  <mj-attributes>
    <mj-title>This is the title.</mj-title>
    <mj-all font-family="-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji"></mj-all>
    <mj-class name="title-text" font-size="21px" line-height="28px" color="#333" font-weight="600"></mj-class>
    <mj-class name="body-text" font-size="16px" line-height="22px" color="#746A6A"></mj-class>
    <mj-class name="cta-button" width="100%" background-color="${colors.primary}" height="34px" font-weight="500" font-size="17px" padding-top="5px"></mj-class>
    <mj-class name="nav-link" text-transform="default" color="#FFFFFF"></mj-class>
  </mj-attributes>
  <mj-style inline="inline">
    .outer-card {
      box-shadow: 0px 3.32057px 10px rgba(0, 0, 0, 0.10);
      border-radius: 3px;
      overflow: hidden;
      padding: 0;
      border-top: 3px solid ${colors.primary}
    }

    .unsubscribe-link {
      color: #9C9090;
      font-size: 11px
    }
  </mj-style>
</mj-head>
<mj-body width="480px" background-color="#EFEBEE">
  <mj-wrapper background-color="white" css-class="outer-card" padding="0">
    <mj-section padding="0" border-bottom="1px solid #dedede" padding-top="7px" padding-bottom="7px">
      <mj-group>
        <mj-column padding="0" width="30%" vertical-align="middle">
          <mj-image src="${coloredLogoUrl}" width="75px" align="left" padding-left="20px"></mj-image>
        </mj-column>
        <mj-column width="70%" vertical-align="middle">
          <mj-text align="right" color="#333">${hotelName}</mj-text>
        </mj-column>
      </mj-group>
    </mj-section>
    <mj-section padding="0">
      <mj-column padding="0">
        <mj-image src="${sections.main.heroImgUrl}" padding-left="0" align="center" width="480px" padding-right="0" padding-top="0"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section padding-top="10px" padding-left="10px" padding-right="10px">
      <mj-column>
        <mj-text mj-class="title-text">${sections.main.title}</mj-text>
        <mj-text mj-class="body-text">${sections.main.description}</mj-text>
      </mj-column>
    </mj-section>
    <mj-section padding-top="0" padding-bottom="20px" padding-left="10px" padding-right="10px">
      <mj-column>
        <mj-button mj-class="cta-button" href=${sections.main.ctaLink}>
          ${sections.main.cta}
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section padding-bottom="0">
      <mj-group>
        <mj-column>
          <mj-image src="${sections.aboutHotel.photos[0]}" padding="0" href=${primaryWebsiteUrl} />
        </mj-column>
        <mj-column>
          <mj-image src="${sections.aboutHotel.photos[1]}" padding="0" href=${primaryWebsiteUrl} />
        </mj-column>
        <mj-column>
          <mj-image src="${sections.aboutHotel.photos[2]}" padding="0" href=${primaryWebsiteUrl} />
        </mj-column>
      </mj-group>
    </mj-section>
    <mj-section padding-top="20px" padding-left="10px" padding-right="10px" padding-bottom="10px">
      <mj-column>
        <mj-text mj-class="title-text">${sections.aboutHotel.title}</mj-text>
        <mj-text mj-class="body-text">${sections.aboutHotel.description} </mj-text>
      </mj-column>
    </mj-section>
    <mj-section padding-bottom="0">
      <mj-column border-bottom="1px solid #E6E6E6" border-top="1px solid #E6E6E6">
        <mj-image src="https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=16&size=450x240&maptype=roadmap&key=AIzaSyB2Q7iadrg9-SaymDF_l5pUOhLaOiW01vM&scale=2" padding="0" href="https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}" />
      </mj-column>
    </mj-section>
    <mj-section border-bottom="1px solid #E6E6E6" padding-top="18px" padding-bottom="18px">
      <mj-group>
        <mj-column>
          <mj-social icon-size="28px" mode="horizontal" align="center" padding="0">
            <mj-social-element src="${assetURL}/call.png" name="cta" padding="0 10px 0 0" href="tel:${hotelPhoneNumber}" font-size="17px" font-weight="500" line-height="20px">
              Call
            </mj-social-element>
          </mj-social>
        </mj-column>
        <mj-column>
          <mj-social icon-size="28px" mode="horizontal" align="center" padding="0">
            <mj-social-element src="${assetURL}/text.png" name="cta" padding="0 10px 0 0" href="sms:${hotelPhoneNumber}" font-size="17px" font-weight="500" line-height="20px">
              Text
            </mj-social-element>
          </mj-social>
        </mj-column>
        <mj-column>
          <mj-social icon-size="28px" mode="horizontal" align="center" padding="0">
            <mj-social-element src="${assetURL}/directions.png" name="cta" padding="0 10px 0 0" font-size="17px" line-height="20px" font-weight="500" href="https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}" >
              Directions
            </mj-social-element>
          </mj-social>
        </mj-column>
      </mj-group>
    </mj-section>
    <mj-section padding-top="15px" padding-left="0" padding-right="10px" padding-bottom="0">
      <mj-group>
        <mj-column width="15%" padding-left="0">
          <mj-image src="${assetURL}/locationIcon.png" width="20px" height="20px" padding-left="0" padding-right="0" />
        </mj-column>
        <mj-column width="85%" padding-left="0">
          <mj-text mj-class="body-text" padding-left="0">${invoiceAddress}</mj-text>
        </mj-column>
      </mj-group>
    </mj-section>
    <mj-section padding-top="0" padding-left="0" padding-right="10px">
      <mj-group>
        <mj-column width="15%" padding-left="0" padding-top="0">
          <mj-image src="${assetURL}/phoneIcon.png" width="20px" height="20px" padding-left="0" padding-right="0" />
        </mj-column>
        <mj-column width="85%" padding-left="0">
          <mj-text mj-class="body-text" padding-left="0">${reservationHotLine}</mj-text>
        </mj-column>
      </mj-group>
    </mj-section>
    <mj-section background-color="${colors.primary}">
      <mj-group>
        <mj-column width="20%" padding-left="20px" padding-top="0" vertical-align="middle">
          <mj-image src="${whiteLogoUrl}" width="60px" padding-left="0" padding-right="0" />
        </mj-column>
        <mj-column width="80%" padding-left="0px" padding-top="0" vertical-align="middle">
          <mj-text color="white" font-size="15px">${hotelName}</mj-text>
        </mj-column>
      </mj-group>
    </mj-section>
  </mj-wrapper>
  <mj-section padding-bottom="0">
    <mj-column>
      <mj-text color="#9C9090" font-size="11px" align="center">${invoiceAddress}</mj-text>
    </mj-column>
  </mj-section>
  <mj-section padding-top="0">
    <mj-column >
      <mj-text color="white" align="center" padding-top="0">
        <a href="" class="unsubscribe-link">Unsubscribe from list</a>
      </mj-text>
    </mj-column>
  </mj-section>
</mj-body>
</mjml>`

export default getBaseEmailTemplate
